module.exports = __webpack_public_path__ + "img/app-jp.ee76a764.png";